// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  aspect-ratio: 1.1 / 1;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.app-card:hover {
  transform: translateY(-4px);
  border-color: rgba(255, 255, 255, 0.08);
  background: var(--bg-glass-hover);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);
}

/* ── 3-Dot Action Menu ── */
.app-card__menu-container {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 5;
}

.app-card__menu-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.app-card__menu-btn:hover {
  background: rgba(255, 255, 255, 0.04);
  color: var(--text-primary);
}

/* Dropdown Menu styling */
.app-card__dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 6px;
  width: 170px;
  background: #0f1626;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  animation: slide-fade 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  padding: 6px;
}

@keyframes slide-fade {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.app-card__dropdown-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  font-family: var(--font-sans);
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--text-secondary);
  border-radius: var(--radius-sm);
  transition: all 0.2s ease;
  text-align: left;
}

.app-card__dropdown-item:hover {
  color: var(--text-primary);
  background: rgba(255, 255, 255, 0.04);
}

.app-card__dropdown-item--danger:hover {
  color: var(--accent-rose);
  background: rgba(239, 68, 68, 0.08);
}

.app-card__dropdown-divider {
  height: 1px;
  background: var(--border-subtle);
  margin: 4px 6px;
}

/* ── Brand Logo Centering ── */
.app-card__logo-wrapper {
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 100%;
}

.app-card__logo-svg {
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.25));
  transition: transform 0.3s ease;
}

.app-card:hover .app-card__logo-svg {
  transform: scale(1.08);
}

/* Custom Text Logos styles */
.app-card__logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  padding: 8px 16px;
  font-family: var(--font-family);
  font-weight: 800;
  line-height: 1.1;
  text-transform: uppercase;
}

.app-card__logo-container--green {
  background: #15803d; /* Dark Green theme */
  color: white;
  border: 2px solid #22c55e;
  box-shadow: 0 4px 12px rgba(21, 128, 61, 0.3);
}

.autocab-text-top {
  font-size: 1.15rem;
  letter-spacing: 0.5px;
}

.autocab-text-bottom {
  font-size: 0.68rem;
  background: #facc15; /* yellow taxi text highlight */
  color: black;
  padding: 1px 4px;
  border-radius: 2px;
  font-weight: 900;
  margin-top: 1px;
  letter-spacing: 1px;
}

.app-card__logo-container--nudg {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  background: transparent;
  color: var(--text-primary);
  font-size: 1.85rem;
  font-weight: 800;
  letter-spacing: -1.5px;
  text-transform: lowercase;
  gap: 0;
  position: relative;
}

.nudg-text-n {
  color: #06b6d4; /* cyan */
}

.nudg-text-udg {
  color: #10b981; /* emerald */
}

.nudg-dot {
  width: 5px;
  height: 5px;
  background: #10b981;
  border-radius: 50%;
  margin-left: 1px;
  box-shadow: 0 0 5px #10b981;
}

/* ── App Card Title ── */
.app-card__title {
  font-family: var(--font-family);
  font-weight: 600;
  font-size: 1.05rem;
  color: var(--text-primary);
  letter-spacing: -0.2px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppCard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,wDAAwD;EACxD,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mDAAmD;EACnD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,YAAY;EACZ,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,+BAA+B;EACpD,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,SAAS;AAC3B;;AAEA;EACE,cAAc,EAAE,YAAY;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb","sourcesContent":[".app-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 24px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  aspect-ratio: 1.1 / 1;\n  text-align: center;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.app-card:hover {\n  transform: translateY(-4px);\n  border-color: rgba(255, 255, 255, 0.08);\n  background: var(--bg-glass-hover);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);\n}\n\n/* ── 3-Dot Action Menu ── */\n.app-card__menu-container {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  z-index: 5;\n}\n\n.app-card__menu-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.app-card__menu-btn:hover {\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text-primary);\n}\n\n/* Dropdown Menu styling */\n.app-card__dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 6px;\n  width: 170px;\n  background: #0f1626;\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n  animation: slide-fade 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  padding: 6px;\n}\n\n@keyframes slide-fade {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.app-card__dropdown-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  font-family: var(--font-sans);\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  border-radius: var(--radius-sm);\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.app-card__dropdown-item:hover {\n  color: var(--text-primary);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.app-card__dropdown-item--danger:hover {\n  color: var(--accent-rose);\n  background: rgba(239, 68, 68, 0.08);\n}\n\n.app-card__dropdown-divider {\n  height: 1px;\n  background: var(--border-subtle);\n  margin: 4px 6px;\n}\n\n/* ── Brand Logo Centering ── */\n.app-card__logo-wrapper {\n  margin-bottom: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 60px;\n  width: 100%;\n}\n\n.app-card__logo-svg {\n  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.25));\n  transition: transform 0.3s ease;\n}\n\n.app-card:hover .app-card__logo-svg {\n  transform: scale(1.08);\n}\n\n/* Custom Text Logos styles */\n.app-card__logo-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md);\n  padding: 8px 16px;\n  font-family: var(--font-family);\n  font-weight: 800;\n  line-height: 1.1;\n  text-transform: uppercase;\n}\n\n.app-card__logo-container--green {\n  background: #15803d; /* Dark Green theme */\n  color: white;\n  border: 2px solid #22c55e;\n  box-shadow: 0 4px 12px rgba(21, 128, 61, 0.3);\n}\n\n.autocab-text-top {\n  font-size: 1.15rem;\n  letter-spacing: 0.5px;\n}\n\n.autocab-text-bottom {\n  font-size: 0.68rem;\n  background: #facc15; /* yellow taxi text highlight */\n  color: black;\n  padding: 1px 4px;\n  border-radius: 2px;\n  font-weight: 900;\n  margin-top: 1px;\n  letter-spacing: 1px;\n}\n\n.app-card__logo-container--nudg {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 1.85rem;\n  font-weight: 800;\n  letter-spacing: -1.5px;\n  text-transform: lowercase;\n  gap: 0;\n  position: relative;\n}\n\n.nudg-text-n {\n  color: #06b6d4; /* cyan */\n}\n\n.nudg-text-udg {\n  color: #10b981; /* emerald */\n}\n\n.nudg-dot {\n  width: 5px;\n  height: 5px;\n  background: #10b981;\n  border-radius: 50%;\n  margin-left: 1px;\n  box-shadow: 0 0 5px #10b981;\n}\n\n/* ── App Card Title ── */\n.app-card__title {\n  font-family: var(--font-family);\n  font-weight: 600;\n  font-size: 1.05rem;\n  color: var(--text-primary);\n  letter-spacing: -0.2px;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
